const removeInvalidHtmlChars = input => input.replace(/[^a-zA-Z0-9-._:]/g, '').toLowerCase();

export default removeInvalidHtmlChars;
